module.exports = __webpack_public_path__ + "img/leaderboard.3ffcca4.svg";